const changeFilter = category => ({
  type: 'CHANGE_FILTER',
  category,
});

export default changeFilter;
